<script setup lang="ts">
  import { useFlowConfigStore } from '@/store/flow-config.store'
  import { FormInput, Modal, UiButton, useToastStore } from '@logistiek-zonder-papier/lzp-library'
  import { isAxiosError } from 'axios'
  import type { UUID } from 'node:crypto'
  import { ref } from 'vue'

  const configStore = useFlowConfigStore()
  const toastStore = useToastStore()

  const flowBody = ref<string>('')

  const isSubmitting = ref(false)

  const { subAppId } = defineProps<{ subAppId: UUID }>()

  const show = defineModel<boolean>('show', { default: false })

  async function submit() {
    try {
      await configStore.importFlow(flowBody.value, subAppId)

      toastStore.success('Flow imported.')
      show.value = false
    } catch (error) {
      if (isAxiosError(error)) {
        console.log(error)
        toastStore.error('Could not import flow.')
      } else {
        throw error
      }
    }
  }
</script>

<template>
  <Modal v-model:show="show">
    <template #header>
      <h3>Flow importeren</h3>
    </template>

    <FormInput label="Flow" type="text" v-model="flowBody" :textarea="true" />

    <template #footer="{ close }">
      <UiButton variant="default" type="submit" label="Annuleren" @click="close" />
      <UiButton
        variant="prominent"
        type="submit"
        label="Importeren"
        :disabled="isSubmitting"
        @click="submit"
      />
    </template>
  </Modal>
</template>

<style lang="css" scoped></style>
